/**
 * Marks a component as a "detail page" that MUST be rendered through
 * `<app-detail-page-shell>`. CI enforces the contract via
 * `frontend/scripts/check-detail-pages.mjs`.
 *
 * Apply directly above `@Component`:
 *   @DetailPage()
 *   @Component({ ... })
 *   export class WidgetDetailPageComponent { }
 *
 * At runtime the shell verifies its host class is registered and emits a
 * dev-mode console warning if not — that catches the inverse mistake (using
 * the shell without the decorator).
 */

const _registry = new Set<unknown>()

export function DetailPage(): ClassDecorator {
    return target => {
        _registry.add(target)
        return target
    }
}

export const DetailPageRegistry = {
    has(target: unknown): boolean {
        return _registry.has(target)
    },
    size(): number {
        return _registry.size
    }
}
